import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { PlatformService } from '@app/shared/services/platform/platform.service';
import { Store, select } from '@ngrx/store';
import { IAppState } from '@app/store';
import * as fromUser from '@app/core/user/store/reducers';
import { IUserPrivacySettings } from '../user/store/reducers/user.reducers';
import { PrivacyPolicyService } from './services/privacy-policy.service';

@Component({
  selector: 'vc-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {
  privacySettings: IUserPrivacySettings;

  constructor(
    private plateformService: PlatformService,
    private store: Store<IAppState>,
    private changeDetector: ChangeDetectorRef,
    private privacyPolicyService: PrivacyPolicyService
  ) {}

  ngOnInit() {
    if (this.plateformService.isBrowser) {
      this.store.pipe(select(fromUser.getUserPrivacy)).subscribe(
        response => {
          if (response) {
            this.privacySettings = response;
            this.changeDetector.markForCheck();
          } else {
            this.privacyPolicyService.initSettings();
          }
        },
        () => {
          /* Silently catch exception */
        }
      );
    }
  }
}
